import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'
import ContentLink from 'material-ui-legacy/svg-icons/content/link'
import { lightGreenA700 } from 'material-ui-legacy/styles/colors'

import { Formula } from '../UI/FormulaTokens'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

import errors from '../../lib/errors.js'
import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

const linkedIconStyle = {
  display: 'inline-block',
  margin: '0 0 -8px 5px'
}

const formulaTokenStyle = {
  display: 'inline-block',
  margin: '-3px auto 15px auto'
}

class DetailedServiceCard extends React.PureComponent {
  constructor(props) {
    super(props)
    // Data can be received either as service or itemData.
    this.service = this.props.service || this.props.itemData

    this.state = {
      service: this.service || {}
    }
  }

  componentDidMount() {
    const serviceId = this.service ? this.service.id : this.serviceId
    ServiceStore.find(serviceId)
      .then(result => this.setState({ service: result.data }))
      .catch(error =>
        this.setState({ service: {}, error: errors.unpack(error) })
      )
  }

  render() {
    return (
      <ServiceCard
        service={this.state.service}
        closeCallback={this.props.closeCallback}
        editCallback={this.props.editCallback}
        deleteCallback={this.props.deleteCallback}
      />
    )
  }
}

const ServiceCard = props => {
  // Data can be received either as service or itemData.
  const service = props.service || props.itemData
  const {
    formattedName,
    projectTypeName,
    serviceCategoryName,
    serviceCategoryId,
    name,
    description,
    rateUnit,
    formattedRate,
    rateFormulaName,
    rateFormulaId,
    formattedCost,
    costFormulaName,
    costFormulaId,
    notes
  } = service.attributes

  return (
    <Card>
      <CardTitle title={`${projectTypeName}: ${formattedName}`} />

      <CardText>
        {serviceCategoryName && (
          <p>
            <strong>Category:</strong>&nbsp;
            <Link to={`/service-categories/${serviceCategoryId}`}>
              {projectTypeName}: {serviceCategoryName}
            </Link>
          </p>
        )}

        {name && (
          <p>
            <strong>Name:</strong> {name}
          </p>
        )}

        {description && (
          <p>
            <strong>Client-facing name:</strong> {description}
          </p>
        )}

        {rateUnit && (
          <p>
            <strong>Unit:</strong> {rateUnit}
          </p>
        )}

        {formattedRate && (
          <p>
            <strong>Rate:</strong> {formattedRate}
            {rateFormulaId && (
              <ContentLink style={linkedIconStyle} color={lightGreenA700} />
            )}
          </p>
        )}

        {rateFormulaName && (
          <div>
            <Formula
              formulaType="rate"
              name={rateFormulaName}
              value={formattedRate}
              style={formulaTokenStyle}
            />
          </div>
        )}

        {formattedCost && (
          <p>
            <strong>Cost:</strong> {formattedCost}
            {costFormulaId && (
              <ContentLink style={linkedIconStyle} color={lightGreenA700} />
            )}
          </p>
        )}

        {costFormulaName && (
          <div>
            <Formula
              formulaType="cost"
              name={costFormulaName}
              value={formattedCost}
              style={formulaTokenStyle}
            />
          </div>
        )}

        {notes && (
          <p>
            <strong>Notes:</strong> {notes}
          </p>
        )}
      </CardText>

      <CardActions>
        {props.editCallback && <EditButton onTouchTap={props.editCallback} />}
        {props.deleteCallback && (
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete <strong>{formattedName}</strong>?
                There's no undo.
              </p>
            }
          />
        )}
        {props.closeCallback && (
          <CloseButton onTouchTap={props.closeCallback} />
        )}
      </CardActions>
    </Card>
  )
}

export { DetailedServiceCard, ServiceCard }



// WEBPACK FOOTER //
// ./src/components/Services/ServiceCard.jsx